import React, { useEffect, useState, useRef } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';
import { Modal } from '@mui/material';

function RenameSetupModal({CurrentSetup, finalizeRenameResult}){

    const inputRef = useRef(null);
    const idInputRef = useRef(null);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [originalClubId, setOriginalClubId] = useState('');
    const [changingClubIdModal, setChangingClubIdModal] = useState(false);
    const [validClubId, setValidClubId] = useState(true);
    const [clubDescription, setClubDescription] = useState('');
    const [robotFaceMapY, setRobotFaceMapY] = useState('');
    const [robotFaceMapZ, setRobotFaceMapZ] = useState('');
    const [validRobotFaceMap, setValidRobotFaceMap] = useState(true);

    const hasRobotFaceMap = !!CurrentSetup?.TestParameters?.RobotFaceMap;

    const clubDescriptions = [
        'Low Center',
        'High Center'
        
    ];

    useEffect(() => {
        if(inputRef.current !== null){
            setClubDescription(CurrentSetup.ClubDescription);
            inputRef.current.value = CurrentSetup.ClubDescription;
            //inputRef.current.focus();
            //inputRef.current.select();
        }
        if(idInputRef.current !== null){
            idInputRef.current.value = CurrentSetup.ClubId;
            if(CurrentSetup.TaskmanImported){
                idInputRef.current.disabled = true;
            }else{
                setOriginalClubId(CurrentSetup.ClubId);
            }
        }
        if(hasRobotFaceMap){
            setRobotFaceMapY(String(CurrentSetup.TestParameters.RobotFaceMap?.y ?? ''));
            setRobotFaceMapZ(String(CurrentSetup.TestParameters.RobotFaceMap?.z ?? ''));
        }
    },[]);

    const clickResult = (result) => {
        if (result && hasRobotFaceMap && !validRobotFaceMap) {
            return;
        }
        setButtonDisabled(true);
        let value = {};
        if(result){
            value["clubDescription"] = clubDescription;//inputRef.current.value;
            if (hasRobotFaceMap) {
                value["robotFaceMap"] = {
                    y: Number(robotFaceMapY),
                    z: Number(robotFaceMapZ)
                };
            }
            if(!CurrentSetup.TaskmanImported && (idInputRef.current.value !== originalClubId)){
                setChangingClubIdModal(true);
                return;
            }
        }
        finalizeRenameResult(result, value);
    };

    const clickSuperFinalResult = () => {
        setChangingClubIdModal(false);
        let value = {
            clubDescription: inputRef.current.value,
            clubId : idInputRef.current.value
        };
        if (hasRobotFaceMap) {
            value["robotFaceMap"] = {
                y: Number(robotFaceMapY),
                z: Number(robotFaceMapZ)
            };
        }
        finalizeRenameResult(true, value);
    }

    const validateNewId = (e) => {
        const regex = /^HD-\d{7}$/;
        const isValid = regex.test(e.target.value);
        if (isValid) {
            setValidClubId(true);
            setButtonDisabled(hasRobotFaceMap ? !validRobotFaceMap : false);
        } else {
            setValidClubId(false);
            setButtonDisabled(true);
        }
    }

    const updateRobotFaceMapValidity = (nextY, nextZ) => {
        const isValid =
            nextY.trim() !== '' &&
            nextZ.trim() !== '' &&
            Number.isFinite(Number(nextY)) &&
            Number.isFinite(Number(nextZ));

        setValidRobotFaceMap(isValid);

        if (hasRobotFaceMap) {
            setButtonDisabled(!isValid || !validClubId);
        }
    };

    const handleRobotFaceMapYChange = (e) => {
        const nextValue = e.target.value;
        setRobotFaceMapY(nextValue);
        updateRobotFaceMapValidity(nextValue, robotFaceMapZ);
    };

    const handleRobotFaceMapZChange = (e) => {
        const nextValue = e.target.value;
        setRobotFaceMapZ(nextValue);
        updateRobotFaceMapValidity(robotFaceMapY, nextValue);
    };

    return (
    <div className='modal-container' style={{ height: hasRobotFaceMap ? "560px" : "400px", maxWidth: "400px" }}>
        <button className='modal-close-button' onClick={() => clickResult(false)}>
            <Cross2Icon width='30px' height='30px' />
        </button>

        <div className='modal-header'>Edit setup</div>

        <div className='modal-content' style={{ position: 'relative' }}>
            <span>Club Description</span>
            
            <div style={{ position: 'relative', width: '100%' }}>
                <input
                    className="input"
                    list="clubDescriptions"
                    ref={inputRef}
                    value={clubDescription}
                    onChange={(e) => setClubDescription(e.target.value)}
                />

                <datalist id="clubDescriptions">
                    <option value="Low Center" />
                    <option value="High Center" />
                </datalist>
            </div>
        </div>

        <div className='modal-content'>
            <span>Club ID</span>
            <div style={{ width: '100%', border: validClubId ? '0' : '3px solid red' }}>
                <input
                    className='input'
                    type='text'
                    ref={idInputRef}
                    onChange={(e) => validateNewId(e)}
                />
            </div>
        </div>

        {hasRobotFaceMap && (
            <>
                <div className='modal-content'>
                    <span>+Toe / -Heel</span>
                    <div style={{ width: '100%', border: validRobotFaceMap ? '0' : '3px solid red' }}>
                        <input
                            className='input'
                            type='number'
                            step='0.01'
                            value={robotFaceMapY}
                            onChange={handleRobotFaceMapYChange}
                        />
                    </div>
                </div>

                <div className='modal-content'>
                    <span>+Up / -Down</span>
                    <div style={{ width: '100%', border: validRobotFaceMap ? '0' : '3px solid red' }}>
                        <input
                            className='input'
                            type='number'
                            step='0.01'
                            value={robotFaceMapZ}
                            onChange={handleRobotFaceMapZChange}
                        />
                    </div>
                </div>
            </>
        )}

        <div className="modal-footer">
            <button
                disabled={buttonDisabled}
                className="button"
                style={{ width: '100px' }}
                onClick={() => clickResult(true)}
            >
                Rename
            </button>
        </div>

        <Modal open={changingClubIdModal}>
            <div className='modal-container' style={{ height: "200px", maxWidth: "400px" }}>
                <button className='modal-close-button' onClick={() => setChangingClubIdModal(false)}>
                    <Cross2Icon width='30px' height='30px' />
                </button>

                <div className='modal-header'>Changing Club ID</div>

                <div className='modal-content'>
                    {"You are attempting to change the Club ID to " +
                        (idInputRef.current !== null ? idInputRef.current.value : "") +
                        " (from " + originalClubId + "). Are you sure?"}
                </div>

                <div className="modal-footer">
                    <button
                        className="button"
                        style={{ width: '100px' }}
                        onClick={() => clickSuperFinalResult()}
                    >
                        Yes
                    </button>
                </div>
            </div>
        </Modal>
    </div>
);
}

export default RenameSetupModal;
